import api from '../utils/api';

// Fetch all Reservations
export const getReservations = async (headers) => {
  try {
    const response = await api.get('/api/reservations/reservations', headers);
    console.log(" getReservations  ", response.data)
    return response.data;
  } catch (error) {
    console.error('Error fetching reservations:', error.response ? error.response.data : error.message);
    throw error;
  }
};

// Fetch a specific Reservation by ID
export const getReservationById = async (id, headers) => {
  try {
    const response = await api.get(`/api/reservations/reservations/${id}`, headers);
    console.log(" getReservationById  ", response.data)
    return response.data;
  } catch (error) {
    console.error(`Error fetching reservation with ID ${id}:`, error.response ? error.response.data : error.message);
    throw error;
  }
};

// Create a new Reservation
export const createReservation = async (reservationData, headers) => {
  try {
    const response = await api.post('/api/reservations/reservations', reservationData, headers);
    return response.data;
  } catch (error) {
    console.error('Error creating reservation:', error.response ? error.response.data : error.message);
    throw error;
  }
};

// Update an existing Reservation
export const updateReservation = async (id, reservationData, headers) => {
  try {
    const response = await api.put(`/api/reservations/reservations/${id}`, reservationData, headers);
    return response.data;
  } catch (error) {
    console.error(`Error updating reservation with ID ${id}:`, error.response ? error.response.data : error.message);
    throw error;
  }
};

// Delete a Reservation
export const deleteReservation = async (id, headers) => {
  try {
    const response = await api.delete(`/api/reservations/reservations/${id}`, headers);
    return response.data;
  } catch (error) {
    console.error(`Error deleting reservation with ID ${id}:`, error.response ? error.response.data : error.message);
    throw error;
  }
};
